{
    "coordinates": [
        20.722467743936676,
        -77.3070171286546
    ],
    "tooltip": "Pleistocene Cuba",
    "title": "Pleistocene Cuba",
    "country": "Cuba",
    "period": "Quaternary",
    "image": {
        "file": "artworks/Cuba_Pleistocen.png",
        "size": "500px"
    }
}
